import { gql } from 'graphql-tag'
import { fragmentModuleChapter, fragmentModuleMedia } from '#layers/core/data-layer/modules/fragments'
import { fragmentBlockCallToAction } from '#layers/core/data-layer/blocks/fragments'
import queryPageFields from '#layers/core/data-layer/pages/page/query-page-fields'

export default gql`
  ${fragmentModuleChapter}
  ${fragmentBlockCallToAction}
  ${fragmentModuleMedia}
  query($slug: String! = "", $sysId: String! = "", $locale: String!, $withParent: Boolean! = false, $slugParent: String! = "", $preview: Boolean! = false) {
    page: pageLegalDetailCollection(limit: 1, where: { OR: [{ sys: { id: $sysId }}, { slug: $slug }]}, locale: $locale, preview: $preview) {
      items {
        ${queryPageFields}
        defaultLocaleFallbackEnabled
        introText {
          json
        }
        downloadDocument {
          ...ModuleMediaFragment
        }
        numberedDocument
        chaptersCollection(limit: 20) {
          items {
            ...ModuleChapterFragment
          }
        }
        callToAction {
          ...BlockCallToActionFragment
        }
      }
    }
    pageParent: pageLegalCollection(limit: 1, where: { slug: $slugParent }, locale: $locale, preview: $preview) @include(if: $withParent) {
      items {
        sys {
          id
        }
        title
        itemsCollection {
          items {
             sys {
              id
            }
            navigationTitle
          }
        }
      }
    }
  }
`
